import * as React from 'react'

const EnvironmentContext = React.createContext(window.env)

export default EnvironmentContext



// WEBPACK FOOTER //
// ./src/components/EnvironmentContext/EnvironmentContext.tsx